import { capitaliseFirstLetter } from 'utils/capitaliseFirstLetter';
import { AtsProvider } from 'services/integration/types';

/**
 * Formats an ATS provider name for display in the UI
 * @param provider - The ATS provider string (e.g., 'lever', 'bullhorn_ats')
 * @returns Formatted provider name (e.g., 'Lever', 'Bullhorn')
 */
export const formatAtsProviderName = (
  provider: string | undefined | null
): string => {
  if (!provider) {
    return 'ATS';
  }

  const displayName =
    provider === AtsProvider.bullhorn_ats || provider === AtsProvider.bullhorn
      ? 'Bullhorn'
      : provider;

  return capitaliseFirstLetter(displayName);
};
